import { useCallback } from 'react';

import { PaymentTabData } from '@/features/settings/types';
import { useCreateStripePortalSessionMutation, useGetCurrentUserSubscription } from '@/shared/hooks/queries/generated';

export const usePaymentTabData = (): PaymentTabData => {
  // Queries
  const { data: currentUserSubscriptionData } = useGetCurrentUserSubscription(
    {},
    {
      refetchInterval: 5000,
    },
  );

  // Mutations
  const createPortalSession = useCreateStripePortalSessionMutation();

  // Handle payment method and invoices
  const handlePaymentMethodAndInvoices = useCallback(async () => {
    try {
      const result = await createPortalSession.mutateAsync({
        input: {
          type: 'paymentMethodAndInvoices',
          returnUrl: window.location.href,
        },
      });

      if (result.createStripePortalSession.url) {
        window.location.href = result.createStripePortalSession.url;
      }
    } catch (error) {
      console.error('Error creating payment portal session:', error);
      throw error;
    }
  }, [createPortalSession]);

  // Handle subscription cancel
  const handleSubscriptionCancel = useCallback(async () => {
    try {
      const result = await createPortalSession.mutateAsync({
        input: {
          type: 'subscriptionCancel',
          returnUrl: window.location.href,
        },
      });

      if (result.createStripePortalSession.url) {
        window.location.href = result.createStripePortalSession.url;
      }
    } catch (error) {
      console.error('Error creating cancellation portal session:', error);
      throw error;
    }
  }, [createPortalSession]);

  const userSubscription = currentUserSubscriptionData?.getCurrentUserSubscription;

  const isActive = userSubscription?.isActive ?? false;
  // Résiliation programmée (actif jusqu'à la fin de la période) ou abonnement déjà terminé.
  const endAt = isActive ? userSubscription?.cancelAt : userSubscription?.inactivatedAt;

  return {
    handlePaymentMethodAndInvoices,
    handleSubscriptionCancel,
    showCancelButton: isActive && !userSubscription?.cancelAt,
    cancelAt: endAt ? new Date(endAt) : null,
  };
};
